import {createActionTypes, createActionCreators} from 'utils/reduxUtils';

const typesArray = [
    'TRACKING_ACTION',
];

export const ActionTypes = createActionTypes(typesArray);
export const Actions = createActionCreators(typesArray);
